<div class="modules container grid">
  <!-- <h3 class="w-700 blue-50 text-center">
    Il programma del corso è suddiviso in 12 moduli.
  </h3> -->
  <p class="w-500 neutral-100px-2 px-xl-5">
    {{ data.text }}
  </p>
</div>
